import { useState, useEffect } from 'react'

const useJourneyRoutes = (
  routes: any[],
  selectedRoutes: any[],
  updateRoutes: (routes: any[]) => void,
  drawRoutes: (routeIds: number[]) => void,
) => {
  const [newRoutes, setNewRoutes] = useState(routes)

  useEffect(() => {
    if (routes.length > newRoutes.length) {
      const newRoute = routes[routes.length - 1]
      const updatedRoutes = [...selectedRoutes, {
        value: newRoute.properties.id,
        label: newRoute.properties.name,
      }]
      updateRoutes(updatedRoutes)
      drawRoutes(updatedRoutes.map((route: any) => route.value))
    }
    setNewRoutes(routes)
  }, [routes, newRoutes, selectedRoutes, drawRoutes])
}

export default useJourneyRoutes
